export class Billers {
    public ACC_CODE!: string;
    public ACC_NAME!: string;
    public ADDRESS!: string;
}